import { render, staticRenderFns } from "./ChatTableBlock.vue?vue&type=template&id=c915f6e2&scoped=true"
import script from "./ChatTableBlock.vue?vue&type=script&lang=js"
export * from "./ChatTableBlock.vue?vue&type=script&lang=js"
import style0 from "./ChatTableBlock.vue?vue&type=style&index=0&id=c915f6e2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c915f6e2",
  null
  
)

export default component.exports